// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import CreditCardPageHeaderWrapper from './styles/CreditCardPageHeader.style';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblBack,
} from '../../../../../../utils/labels/globalActions.labels';

const CreditCardPageHeader = ({ isPLCCModalFlow }) => {
  const cardHeading = 'dynamic.global_d.lbl_PLCCForm_rewardsCardHeading';
  return !isPLCCModalFlow ? (
    <CreditCardPageHeaderWrapper>
      <Row fullBleed>
        <Col
          className="back_button_container"
          key={renderLabel(
            getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
              GlobalActionsLabels
            ),
            'lbl_back'
          )}
          colSize={{ large: 12, medium: 8, small: 6 }}
        >
          <Anchor href="#" noLink data-locator="plcc_back_btn" onClick={() => Router.back()}>
            <span className="left-arrow"> </span>
            <BodyCopy component="span" className="back_button">
              {renderLabel(
                getLabelFromCopyOrFromTranslation(
                  `${GLOBAL_ACTIONS_LABELS}.${lblBack}`,
                  GlobalActionsLabels
                ),
                'lbl_back'
              )}
            </BodyCopy>
          </Anchor>
        </Col>
      </Row>
      <Row fullBleed>
        <Col
          className="apply_Card_Header_Text"
          key={getDynamicLabelValues(cardHeading)}
          aria-label={getDynamicLabelValues(cardHeading)}
          colSize={{ large: 12, medium: 8, small: 6 }}
        >
          <BodyCopy
            component="h1"
            fontSize="fs16"
            fontWeight="extrabold"
            className="credit_card_heading"
            data-locator={getDynamicLabelValues(cardHeading)}
          >
            {getDynamicLabelValues(cardHeading)}
          </BodyCopy>
        </Col>
      </Row>
    </CreditCardPageHeaderWrapper>
  ) : null;
};

CreditCardPageHeader.propTypes = {
  labels: PropTypes.shape({}).isRequired,
  isPLCCModalFlow: PropTypes.bool.isRequired,
};

export default CreditCardPageHeader;
